<div class="modal-content">
  <apm-section-title
    icon="t_news"
    title="{{
      (isNews$ | async)
        ? ((dialogData?.newsId ? '444818' : '444817') | apmTranslate)
        : ((dialogData?.newsId ? '444820' : '444819') | apmTranslate)
    }}"
  ></apm-section-title>

  <mat-stepper class="stepper-content-modal-xl" #stepper linear>
    <mat-step [completed]="form.valid">
      <ng-template matStepLabel>{{ '444821' | apmTranslate }}</ng-template>
      <apm-news-admin-dialog-creation-step
        [form]="$any(fc.creation)"
        [statuses$]="statuses$"
      ></apm-news-admin-dialog-creation-step>
    </mat-step>
    @if (isNews$ | async) {
      <mat-step [completed]="form.valid">
        <ng-template matStepLabel>{{ '444822' | apmTranslate }}</ng-template>
        <apm-news-admin-dialog-visibility-step [form]="$any(fc.visibility)"></apm-news-admin-dialog-visibility-step>
      </mat-step>
    }
    <mat-step [completed]="form.valid">
      <ng-template matStepLabel>{{ '444824' | apmTranslate }}</ng-template>
      <apm-news-admin-dialog-tag-step [form]="$any(fc.tags)"></apm-news-admin-dialog-tag-step>
    </mat-step>
  </mat-stepper>

  <div class="row justify-content-end">
    <div class="d-flex justify-content-between gap-4">
      <apm-button class="w-25" variant="secondary" (click)="closeDialog()">{{ '444714' | apmTranslate }}</apm-button>
      <div class="d-flex gap-4 w-50 justify-content-end">
        @if (canConvertToArticle) {
          <div>
            @if ((isNews$ | async) && dialogData?.newsId) {
              <apm-button class="w-50" variant="secondary" (buttonClick)="convertToArticle()">
                {{ '448691' | apmTranslate }}
              </apm-button>
            }
          </div>
        }
        @if (
          ((isNews$ | async) && stepper.selectedIndex !== 2) || (!(isNews$ | async) && stepper.selectedIndex !== 1)
        ) {
          <apm-button
            class="w-50"
            [disabled]="stepper.selectedIndex === 0 && !form.valid"
            (buttonClick)="form.valid && goNext()"
          >
            {{ '444727' | apmTranslate }}
          </apm-button>
        }
        @if (
          ((isNews$ | async) && stepper.selectedIndex === 2) || (!(isNews$ | async) && stepper.selectedIndex === 1)
        ) {
          <apm-button class="w-50" [disabled]="!form.valid" (buttonClick)="form.valid && createNews()">{{
            (dialogData?.newsId ? '444718' : '444717') | apmTranslate
          }}</apm-button>
        }
      </div>
    </div>
  </div>
</div>
